var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('b-form-fieldset', [_c('b-form-radio', {
    attrs: {
      "name": "radioInline",
      "id": "radioInline",
      "plain": true,
      "options": _vm.options
    },
    on: {
      "input": function($event) {
        _vm.changeRadio(_vm.selected)
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "opt"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0rem",
      "margin-bottom": "0rem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Name "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.clientLoading
    },
    on: {
      "update:active": function($event) {
        _vm.clientLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('AccountId')
    },
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.ClientAccountList,
      "multiple": _vm.multiple(),
      "name": "AccountId",
      "id": "AccountId",
      "data-ClientId": _vm.ClientId,
      "placeholder": "Select Client",
      "label": "AccountName",
      "track-by": "AccountId",
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.ClientId),
      callback: function($$v) {
        _vm.ClientId = $$v
      },
      expression: "ClientId"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AccountId')),
      expression: "errors.has('AccountId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Client is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("From Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    attrs: {
      "id": "fromDate",
      "type": "date",
      "name": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromDate')),
      expression: "errors.has('fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("From date is required.")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("To Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "date",
      "name": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('toDate')),
      expression: "errors.has('toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("To date is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header d-flex justify-content-between align-items-center"
  }, [_vm._m(2), _vm._v(" "), (_vm.isActiveNow == 1) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportf),
      expression: "exportf"
    }],
    staticClass: "d-flex align-items-center gap-2"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success text-white mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.triggerFileSelect
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload UTR CSV\n                    ")], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportreport()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.excelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.excelLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n            ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.isActiveNow == 2) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportf),
      expression: "exportf"
    }],
    staticStyle: {
      "margin-left": "85%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.exportDelivaryDate()
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.excelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.excelLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n            ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.isActiveNow == 3) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportf),
      expression: "exportf"
    }],
    staticStyle: {
      "margin-left": "85%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.exportDelivaryException()
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.excelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.excelLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n            ")], 1)]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.isActiveNow == 1) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listCODRemitanceData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientremittedid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CompanyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.RemittanceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Cycle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format_date(data.transactiondate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipmentCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CODAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FreightAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.ExceptionAmount > 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(data.ExceptionAWB)
        }
      }
    }, [_vm._v(_vm._s(data.ExceptionAmount))]) : _vm._e(), _vm._v(" "), (data.ExceptionAmount <= 0) ? _c('span', [_vm._v(_vm._s(data.ExceptionAmount))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PaidAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.UTRNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.filepath != null) ? _c('span', [_c('a', {
      attrs: {
        "title": ("" + (data.CompanyName)),
        "href": ("" + (data.filepath))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "20px",
        "color": "#4b8cbb",
        "margin": "10px 10px 1px 1px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (data.filepath == null) ? _c('span', [_c('a', {
      attrs: {
        "title": ("" + (data.CompanyName))
      }
    }, [_vm._v("NA")])]) : _vm._e()])])
  })], 2)]) : _vm._e(), (_vm.isActiveNow == 1 && _vm.resultCount > 1) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isActiveNow == 1 && _vm.resultCount > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isActiveNow == 2) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [(_vm.resultCountDate == 0) ? _c('tr', [_vm._m(6)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listCODRemitanceDataDate), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientremittedid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CompanyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.RemittanceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.format_date(data.deliverydate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Cycle))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipmentCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CODAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FreightAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.ExceptionAmount > 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(data.ExceptionAWB)
        }
      }
    }, [_vm._v(_vm._s(data.ExceptionAmount))]) : _vm._e(), _vm._v(" "), (data.ExceptionAmount <= 0) ? _c('span', [_vm._v(_vm._s(data.ExceptionAmount))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PaidAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.UTRNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.filepath != null) ? _c('span', [_c('a', {
      attrs: {
        "title": ("" + (data.CompanyName)),
        "href": ("" + (data.filepath))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "20px",
        "color": "#4b8cbb",
        "margin": "10px 10px 1px 1px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (data.filepath == null) ? _c('span', [_c('a', {
      attrs: {
        "title": ("" + (data.CompanyName))
      }
    }, [_vm._v("NA")])]) : _vm._e()])])
  })], 2)]) : _vm._e(), (_vm.isActiveNow == 2 && _vm.resultCountDate > 1) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isActiveNow == 2 && _vm.resultCountDate > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 3,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationDataDate,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isActiveNow == 3) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [(_vm.resultCountException == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listCODPaymentData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format_date(data.ShippingDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.POID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CompanyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.HubName))]), _vm._v(" "), _c('td', [_vm._v("COD")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.newStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format_date(data.DeliveryDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NetPayment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format_date(data.RemittanceDate)))])])
  })], 2)]) : _vm._e(), (_vm.isActiveNow == 3 && _vm.resultCountException > 0) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isActiveNow == 3 && _vm.resultCountException > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataException,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "myReasonModalRef",
    attrs: {
      "id": "#confirmationmodal2",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ReasonModalShow),
      callback: function($$v) {
        _vm.ReasonModalShow = $$v
      },
      expression: "ReasonModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("AWB No/Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(val.Amount))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "1%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.totalSum))])])])], 2)])])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    staticClass: " fa fa-filter filter"
  }), _vm._v(" Remittance Closed Details\n                ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Result\n                ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Remittance Id ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Company Name")])]), _vm._v(" "), _c('th', {
    staticClass: " tableheader"
  }, [_c('b', [_vm._v("Remittance Type")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Cycle")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Transaction Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Count")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Freight Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Exception Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Paid Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UTR #")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Download")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_c('b', [_vm._v("No record found")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Remittance Id ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Company Name")])]), _vm._v(" "), _c('th', {
    staticClass: " tableheader"
  }, [_c('b', [_vm._v("Remittance Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivary Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Cycle")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Count")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Freight Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Exception Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Paid Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UTR #")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Download")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_c('b', [_vm._v("No record found")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("POID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping Id")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Company Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Service Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Net Payment ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Transaction Date")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28bc3c97","hasScoped":true}!./src/views/components/CODRemitanceClose/CODRemitanceClose.component.html
// module id = 394
// module chunks = 1